"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const timePerIndicatorFrame = 200;
exports.default = timePerIndicatorFrame;
